const translations = {
  fr: {
    dashboard: {
      dashboardPageTitle: 'Tableau de bord',
      noCampaignsOrSpotsInLastNDays: 'Vous n\'avez aucune campagne en cours ou aucun spot n\'a été diffusé au cours des {{count}} derniers jours',
      gotoProposedCampaigns: 'Allez à vos campagnes proposées',
      runningCampaigns: 'Campagne en cours',
      runningCampaigns_plural: 'Campagnes en cours',
      numberOfSpots: 'Spot diffusé',
      numberOfSpots_plural: 'Spots diffusés',
      campaignsTotalCost: 'Coût total des campagnes',
    },
  },
  en: {
    dashboard: {
      dashboardPageTitle: 'Dashboard',
      noCampaignsOrSpotsInLastNDays: 'No campaigns are currently running or no spots have aired in the last {{count}} days',
      gotoProposedCampaigns: 'Go to your proposed campaigns',
      runningCampaigns: 'Running Campaign',
      runningCampaigns_plural: 'Running Campaigns',
      numberOfSpots: 'Aired spot',
      numberOfSpots_plural: 'Aired Spots',
      campaignsTotalCost: 'Campaigns Total Cost',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/advertisers/modules/dashboard/i18n/dashboard.js